/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Schließen`
};

const en_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Close`
};

const es_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar`
};

const fr_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Fermer`
};

const it_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Chiudi`
};

const nl_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Sluiten`
};

const pt_profile__close = /** @type {(inputs: {}) => string} */ () => {
	return `Fechar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__close(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__close", locale)
	if (locale === "de") return de_profile__close(inputs)
	if (locale === "en") return en_profile__close(inputs)
	if (locale === "es") return es_profile__close(inputs)
	if (locale === "fr") return fr_profile__close(inputs)
	if (locale === "it") return it_profile__close(inputs)
	if (locale === "nl") return nl_profile__close(inputs)
	return pt_profile__close(inputs)
};